import { GridInputs } from "../../../../../../components/Functional";

const MaterialSent = props => {
  const { formik } = props || {};

  const inputs = {
    className: "grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-16",
    inputs: [{ label: "Text", name: "notes", type: "textarea" }],
  };

  const gridInputProps = {
    formik,
    ...inputs,
  };

  return <GridInputs {...gridInputProps} />;
};

export default MaterialSent;
